import PdfSection from "../../pdfBuilder/components/layout/PdfSection";
import PdfSectionTitle from "../../pdfBuilder/components/typography/PdfSectionTitle";
import PdfPageBrandedSubmission from "../../pdfBuilder/pages/PdfPageBrandedSubmission";
// import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";
import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";
import PDfBuilderSectionUploadedDocuments from "../../pdfBuilder/ui/sections/PDfBuilderSectionUploadedDocuments";

const PdfPageBorrowingEntityInformation = ({ formData }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={"5 of 6"}
      pageTitle={"Borrowing Entity Information"}
      submittedBy={`${formData?.firstName} ${formData?.lastName}`}
      submittedDate={formData?.submission_date}
    >
      <PdfSection>
        <PdfSectionTitle>Entity Details</PdfSectionTitle>

        <PdfBuilderDataItemRow
          label="Has Existing Entity:"
          value={formData?.applicantHasExistingEntity ? "Yes" : "No"}
        />

        {formData?.applicantHasExistingEntity && (
          <>
            <PdfBuilderDataItemRow
              label="Entity Name:"
              value={formData?.entityName}
            />

            <PdfBuilderDataItemRow
              label="Entity Type:"
              value={formData?.entityType}
            />

            <PdfBuilderDataItemRow
              label="State:"
              value={formData?.entityStateOfOrganization}
            />

            <PdfBuilderDataItemRow
              label="Organization Date:"
              type={"date"}
              value={formData?.entityOrganizationDate}
            />

            <PdfBuilderDataItemRow
              label="Ownership Percentage:"
              type={"percent"}
              value={formData?.entityOwnershipPercentage}
            />

            {/* <PdfRow>
              <PdfLabel>Ownership Percentage:</PdfLabel>
              <PdfValue>
                {formatPercent(formData?.applicantEntityPercentOwnership * 100)}
              </PdfValue>
            </PdfRow> */}

            <PdfBuilderDataItemRow
              label="Single Asset Entity:"
              value={formData?.entityAssets ? "Yes" : "No"}
            />
          </>
        )}
      </PdfSection>

      <PDfBuilderSectionUploadedDocuments documents={formData?.documents} />
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageBorrowingEntityInformation;
